<template>
  <option
    :value="value"
    class="body--medium"
  >
    <slot />
  </option>
</template>

<script>
export default {
  name: "CalicoDropdownMenuItem",
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.calico-dropdown-menu-item {
  padding: $space-small $space-medium;
  cursor: pointer;

  &.active,
  &:hover {
    background-color: $color-neutral-lightest;
  }

  &.selected {
    background-color: $color-border-primary;
    color: $color-white;
  }
}
</style>